import React, { useState, useContext, useEffect } from 'react';
import {
  Button,
  Checkbox, Select,
  Space,
  Tooltip
} from 'antd';
import {
  CloseOutlined
} from '@ant-design/icons';

import { SimpleTable } from '../../components';
import './style';

export default React.forwardRef((props, ref) => {
  const { order, suppliers, rows, onCloseCallback } = props;
  const [isShowNoCompleted, setShowNoCompleted] = useState(false);
  const [isShowCompleted, setShowCompleted] = useState(false);
  const [selectedGoodsId, setSelectedGoodsId] = useState(undefined);
  const [selectedSupplierId, setSelectedSupplierId] = useState(undefined);
  const onChangeGoods = (id) => {
    setSelectedGoodsId(id);
  }
  const onChangeSupplier = (id) => {
    setSelectedSupplierId(id);
  }
  const onChangeNoCompleted = (e) => {
    setShowNoCompleted(e.target.checked);
  }
  const onChangeCompleted = (e) => {
    setShowCompleted(e.target.checked);
  }
  useEffect(() => {

  }, []);

  let targetRows = [].concat(rows);
  if (isShowNoCompleted) {
    targetRows = targetRows.filter(x => x.order_goods_count > x.order_goods_ok_count)
  }
  const goodsOptions = [{ id: -1, name: '--全部产品--' }];
  targetRows.forEach(x => {
    if (goodsOptions.find(y => y.id === x.goods_spec_id) === undefined) {
      goodsOptions.push({ id: x.goods_spec_id, name: x.goods_spec_name });
    }
  });
  if (selectedGoodsId > 0) {
    targetRows = targetRows.filter(x => x.goods_spec_id === selectedGoodsId)
  }
  const supplierOptions = [{ id: -1, name: '--全部供应商--' }];
  targetRows.forEach(x => {
    let arr2 = JSON.parse(x.supplier_purchase_detail_count || '[]');
    arr2 = arr2.filter(y => y[1] > 0);
    arr2.forEach((y, i) => {
      if (supplierOptions.find(s => s.id === y[0]) === undefined) {
        supplierOptions.push({ id: y[0], name: suppliers.find(s => s.id === y[0]).name });
      }
    })
  });
  if (selectedSupplierId > 0) {
    targetRows = targetRows.filter(x => {
      let arr2 = JSON.parse(x.supplier_purchase_detail_count || '[]');
      arr2 = arr2.filter(y => y[1] > 0);
      return arr2.find(y => y[0] === selectedSupplierId)
    })
  }

  const header = [
    {
      label: '产品号', width: '120px', render: (text, row, index) => {
        return <span>{row.goods_spec_name}</span>
      }
    },
    {
      label: '尺寸', align: 'center', width: '90px', render: (text, row, index) => {
        return <span>{row.size}</span>
      }
    },
    {
      label: '产品名称', width: '165px', item: 'goods_name'
    },
    {
      label: '订单数量(含补箱)', align: 'right', width: '100px', render: (text, row, index) => {
        return <span>{row.order_goods_purchase_count}</span>
      }
    },
    {
      label: '供应商', width: '240px', render: (text, row, index) => {
        let arr = JSON.parse(row.supplier_ok_detail_count || '[]');
        arr = arr.filter(x => x[1] > 0);
        let arr2 = JSON.parse(row.supplier_purchase_detail_count || '[]');
        arr2 = arr2.filter(x => x[1] > 0);
        if (selectedSupplierId > 0) {
          arr2 = arr2.filter(x => x[0] === selectedSupplierId);
        }
        return <div>
          {
            arr2.map((x, i) => {
              return <span>{suppliers.find(s => s.id === x[0]).name} : {x[1]}件<br /></span>
            })
          }
        </div>
      }
    },
    {
      label: '供应商发货数量', width: '240px', render: (text, row, index) => {
        let arr = JSON.parse(row.supplier_ok_detail_count || '[]');
        arr = arr.filter(x => x[1] > 0);
        let arr2 = JSON.parse(row.supplier_purchase_detail_count || '[]');
        arr2 = arr2.filter(x => x[1] > 0);
        if (selectedSupplierId > 0) {
          arr = arr.filter(x => x[0] === selectedSupplierId);
        }
        return <div>
          {
            arr.map((x, i) => {
              return <span>{(suppliers.find(s => s.id === x[0]) || { name: '供应商已被移除' }).name} : {x[1]}件<br /></span>
            })
          }
        </div>
      }
    },
    // {
    //   label: '供应商发货数量', align: 'right', width: '100px', item: 'order_goods_ok_count'
    // },
    {
      label: '剩余数量', align: 'right', width: '100px', render: (text, row, index) => {
        let diff = row.order_goods_purchase_count - (row.order_goods_ok_count || 0);
        if (selectedSupplierId > 0) {
          let arr = JSON.parse(row.supplier_ok_detail_count || '[]');
          arr = arr.filter(x => x[0] === selectedSupplierId && x[1] > 0);
          let okCnt = 0;
          arr.forEach(x=> {
            okCnt += x[1]
          })
          let arr2 = JSON.parse(row.supplier_purchase_detail_count || '[]');
          arr2 = arr2.filter(x => x[0] === selectedSupplierId && x[1] > 0);
          let purchageCnt = 0;
          arr2.forEach(x=> {
            purchageCnt += x[1];
          })
          diff = purchageCnt - okCnt;
        }
        if (diff === 0) {
          return 0;
        } else if (diff > 0) {
          return <span style={{ color: 'red' }}>{diff}</span>
        } else {
          return <span style={{ color: 'green' }}>{diff}</span>
        }
      }
    },
    {
      label: '', align: 'center', width: '60px', render: (text, row, index) => {
        let arr = JSON.parse(row.supplier_ok_detail_count || '[]');
        arr = arr.filter(x => x[1] > 0);
        let arr2 = JSON.parse(row.supplier_purchase_detail_count || '[]');
        arr2 = arr2.filter(x => x[1] > 0);
        const content = <div style={{ padding: '0 1rem' }}>
          <div style={{ color: 'red' }}><strong>采购明细</strong></div>
          {
            arr2.map((x, i) => {
              return <span>{suppliers.find(s => s.id === x[0]).name} : {x[1]}件<br /></span>
            })
          }
          <br />
          <div style={{ color: 'red' }}><strong>供应商发货明细</strong></div>
          {
            arr.map((x, i) => {
              return <span>{(suppliers.find(s => s.id === x[0]) || { name: '供应商已被移除' }).name} : {x[1]}件<br /></span>
            })
          }
        </div>
        return <Tooltip
          title={content}>
          <Button size="small" type="link">查看</Button>
        </Tooltip>
      }
    }
  ];
  return <div style={{ padding: '0 1rem' }}>
    <Space style={{ padding: '1rem 0' }}>
      <Checkbox checked={isShowNoCompleted} onChange={onChangeNoCompleted}>只显示未完成</Checkbox>
      {/* <Checkbox checked={isShowCompleted} onChange={onChangeCompleted}>已完成</Checkbox> */}
      {
        goodsOptions.length > 1 && <Select
          showSearch="true"
          optionFilterProp="children"
          style={{ width: '240px' }}
          onChange={onChangeGoods}
          defaultValue={-1}>
          {
            goodsOptions.map(x => {
              return <Select.Option key={x.id} value={x.id}>{x.name}</Select.Option>
            })
          }
        </Select>
      }
      <Select
        showSearch="true"
        optionFilterProp="children"
        style={{ width: '240px' }}
        onChange={onChangeSupplier}
        defaultValue={-1}>
        {
          supplierOptions.map(x => {
            return <Select.Option key={x.id} value={x.id}>{x.name}</Select.Option>
          })
        }
      </Select>
    </Space>
    <SimpleTable isPaginition={false} header={header} rows={targetRows} />
    <div style={{ padding: '1rem 0', display: 'flex', justifyContent: 'flex-end' }}>
      <Button onClick={onCloseCallback} icon={<CloseOutlined />}>关 闭</Button>
    </div>
  </div>
});
